import {useQuery} from "@tanstack/react-query";
import {KnowledgeBaseAPI} from "../../services/network/knowledgeBase-api";
import {KNOWLEDGE_BASE_ENDPOINTS} from "../../services/network/endpoints";

/**
 * Хук для получения информации о папке по её ID
 * @param folderId ID папки
 */
export const useFetchKBFolderById = (folderId: string | undefined) => {
    const {
        data,
        isLoading,
        error,
        refetch
    } = useQuery({
        queryKey: [KNOWLEDGE_BASE_ENDPOINTS.FETCH_FOLDER_BY_ID, folderId],
        queryFn: async () => {
            if (!folderId) {
                throw new Error('Folder ID is required');
            }
            return KnowledgeBaseAPI.fetchFolderById(folderId);
        },
        enabled: !!folderId, // Запрос выполняется только если folderId не пустой
        retry: 1,
        staleTime: 1000 * 60 * 5, // 5 минут
        gcTime: 1000 * 60 * 10, // 10 минут
    });

    return {
        folderData: data?.data,
        folderIsLoading: isLoading,
        folderError: error,
        refetchFolder: refetch
    };
};
